import { useQuery } from "@tanstack/react-query";

import { autoDispatchGlobalAccessorialsSchemaArray } from "~/shared/schemas/auto-dispatch-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const getAutoDispatchableAccessorials = async (signal?: AbortSignal) => {
	const signalOptions = signal ? { signal } : undefined;
	const resp = await getAndValidate(
		apiRoutes.GETGLOBALAUTODISPATCHABLEACCESSORIALS,
		autoDispatchGlobalAccessorialsSchemaArray,
		signalOptions,
	);

	if (resp.success) {
		return resp.data;
	} else {
		throw new Error(
			`Failed to fetch auto-dispatchable accessorials: ${resp.error}`,
		);
	}
};

export const useGetGlobalAccessorials = () => {
	const { data, error, isLoading } = useQuery({
		queryKey: ["globalAutoDispatchableAccessorials"],
		queryFn: async ({ signal }) => {
			return await getAutoDispatchableAccessorials(signal);
		},
		staleTime: 0,
		gcTime: 0,
	});
	return {
		globalAccessorials: data,
		error,
		isLoading,
	};
};
